import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ICultureApi } from './base/cultureApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { CultureFilterRequest } from '../models/request/cultureRequest';

const baseRoute: string = 'Culture';

export class CultureApi extends ICultureApi {
  getDomain(request: CultureFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }
}
